// The console shell's imperative session surface ('./session'), mirroring
// cloud-ui's remote/session: react-query is deliberately NOT
// federation-shared, so when an embedding host re-mints the org context it
// cannot reach this bundle's module-singleton query cache any other way —
// without this expose the grafted jobs branch keeps serving the previous
// org's cached data.
//
// BOUNDARY RULE (as jobsBranch.tsx): nothing in this module's import graph
// may touch remote/*, src/theme.ts or src/router.tsx.

import { queryClient } from '../lib/trpc';

/** The host's expired-session handler for the grafted branch's tRPC 401s
 * (null clears): the shell's SessionProvider never mounts in a foreign host,
 * so nothing else would surface them. */
export { setOnSessionExpired } from '../lib/trpc';

/** Reset every cached query so the grafted jobs branch refetches under the
 * re-minted org token. resetQueries (not invalidate): pages refetch from
 * pending instead of rendering the previous org's data while stale — the
 * same choice as cloud-ui's resetForAccountSwitch. */
export const resetForAccountSwitch = (): Promise<void> =>
    queryClient.resetQueries();
